export const styleColorsMainVariant = [
  'blue',
  'orange',
  'yellow',
  'green',
  'red',
  'mint',
  'purple',
  'crimson',
  'brown',
  'gray',
] as const
export type StyleColorsMain = (typeof styleColorsMainVariant)[number]

export const styleColors50Variant = [
  'blue50',
  'orange50',
  'green50',
  'red50',
  'mint50',
  'purple50',
  'crimson50',
  'brown50',
  'gray50',
] as const
export type StyleColors50 = (typeof styleColors50Variant)[number]

export const styleColors100Variant = [
  'blue100',
  'orange100',
  'yellow100',
  'green100',
  'red100',
  'mint100',
  'purple100',
  'crimson100',
  'brown100',
  'gray100',
] as const
export type StyleColors100 = (typeof styleColors100Variant)[number]

export const styleColors200Variant = [
  'blue200',
  'orange200',
  'green200',
  'red200',
  'mint200',
  'purple200',
  'crimson200',
  'brown200',
  'gray200',
] as const
export type StyleColors200 = (typeof styleColors200Variant)[number]

export const styleColors300Variant = [
  'blue300',
  'orange300',
  'green300',
  'red300',
  'mint300',
  'purple300',
  'crimson300',
  'brown300',
  'gray300',
] as const
export type StyleColors300 = (typeof styleColors300Variant)[number]

export const styleColors400Variant = [
  'blue400',
  'orange400',
  'green400',
  'red400',
  'mint400',
  'purple400',
  'crimson400',
  'brown400',
  'gray400',
] as const
export type StyleColors400 = (typeof styleColors400Variant)[number]

export const styleColors500Variant = [
  'blue500',
  'orange500',
  'green500',
  'red500',
  'mint500',
  'purple500',
  'crimson500',
  'brown500',
  'gray500',
] as const
export type StyleColors500 = (typeof styleColors500Variant)[number]

export const styleColors600Variant = [
  'blue600',
  'orange600',
  'green600',
  'red600',
  'mint600',
  'purple600',
  'crimson600',
  'brown600',
  'gray600',
] as const
export type StyleColors600 = (typeof styleColors600Variant)[number]

export const styleColors700Variant = [
  'blue700',
  'orange700',
  'green700',
  'red700',
  'mint700',
  'purple700',
  'crimson700',
  'brown700',
  'gray700',
] as const
export type StyleColors700 = (typeof styleColors700Variant)[number]

export const styleColors800Variant = [
  'blue800',
  'orange800',
  'green800',
  'red800',
  'mint800',
  'purple800',
  'crimson800',
  'brown800',
  'gray800',
] as const
export type StyleColors800 = (typeof styleColors800Variant)[number]

export const styleColors900Variant = [
  'blue900',
  'orange900',
  'green900',
  'red900',
  'mint900',
  'purple900',
  'crimson900',
  'brown900',
  'gray900',
] as const
export type StyleColors900 = (typeof styleColors900Variant)[number]

export const styleColors1000Variant = ['green1000', 'mint1000', 'orange1000', 'purple1000'] as const
export type StyleColors1000 = (typeof styleColors1000Variant)[number]

export const styleColorsGrayVariant = [
  'white',
  'gray1',
  'gray2',
  'gray3',
  'gray4',
  'gray5',
  'gray6',
  'gray7',
  'gray8',
  'gray9',
  'gray10',
  'gray11',
  'gray12',
  'black',
] as const
export type StyleColorsGray = (typeof styleColorsGrayVariant)[number]

export const styleColorsFillsVariant = ['canvas', 'left', 'shade', 'input'] as const
export type StyleColorsFills = (typeof styleColorsFillsVariant)[number]

export const styleColorsBrandsVariant = ['primary', 'secondary', 'error', 'success', 'warning'] as const
export type StyleColorsBrands = (typeof styleColorsBrandsVariant)[number]

export type StyleColors =
  | StyleColorsMain
  | StyleColors50
  | StyleColors100
  | StyleColors200
  | StyleColors300
  | StyleColors400
  | StyleColors500
  | StyleColors600
  | StyleColors700
  | StyleColors800
  | StyleColors900
  | StyleColors1000
  | StyleColorsGray
  | StyleColorsFills
  | StyleColorsBrands
